import styled from 'styled-components'
import { colours } from '@qflow/theme'

/**
 * Common styled components used across Settings views
 * (AlertSettings, Files, Integrations, WmrConfig, ProjectConnectionsSummaryTable)
 */

export const ProjectsData = styled.div`
  flex-grow: 1;
  position: relative;
  background-color: ${colours.WHITE};
  color: ${colours.CORE_NAVY};
  border-radius: 0.625rem;
  padding: 1rem 1.5rem 1rem 1.5rem;
  box-shadow: 0px 1px 3px 0px #00000026;
`

export const TitleBar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.875rem;
  min-height: 2rem;

  & > h3 {
    color: ${colours.CORE_NAVY};
    font-family: 'Jakarta Sans', 'Inter', sans-serif !important;
    font-size: 1.125rem;
    font-weight: 700;
    margin: 0;
  }
`

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
`

export const ContentWrapper = styled.div`
  margin: 0.5rem 0;
`

export const ExtraInfo = styled.div`
  font-size: 0.75rem;
  color: ${colours.BATTLESHIP_GREY};
  margin: 0.5rem 0 0.5rem 0;
`
